module.exports = __webpack_public_path__ + "img/stor_wrapbg4.1d91e12c.png";